module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-900533d8.png";